import React, { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    document.title = "Meilleur Abonnement IPTV En France et Europe | Tv Plux";

    // trackAndRedirect — exposed globally so onclick= in HTML strings can call it
    window.trackAndRedirect = function(url) {
      if (window.fbq) window.fbq('track', 'AddToCart');
      setTimeout(function() {
        window.location.href = url;
      }, 200);
    };

    // Use timeout so dangerouslySetInnerHTML DOM is fully ready before init
    const timer = setTimeout(() => {

      // Init Swiper - channels slider
      if (window.Swiper) {
        const swiperEl = document.querySelector('.card__content');
        if (swiperEl) {
          if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
          new window.Swiper('.card__content', {
            loop: true,
            autoplay: { delay: 600 },
            centeredSlides: true,
            centeredSlidesBounds: true,
            grabCursor: true,
            pagination: { el: '.swiper-pagination', clickable: true, dynamicBullets: true },
            breakpoints: {
              320: { slidesPerView: 2, spaceBetween: 10 },
              480: { slidesPerView: 2, spaceBetween: 10 },
              640: { slidesPerView: 5, spaceBetween: 15 }
            }
          });
        }

        // Init Swiper - feedback slider
        const swiperFeed = document.querySelector('.card__content_feed');
        if (swiperFeed) {
          if (swiperFeed.swiper) swiperFeed.swiper.destroy(true, true);
          new window.Swiper('.card__content_feed', {
            loop: true,
            autoplay: { delay: 2500 },
            centeredSlides: true,
            centeredSlidesBounds: true,
            grabCursor: true,
            pagination: { el: '.swiper-pagination', clickable: true, dynamicBullets: true },
            breakpoints: {
              320: { slidesPerView: 1, spaceBetween: 10 },
              480: { slidesPerView: 1, spaceBetween: 10 },
              640: { slidesPerView: 1, spaceBetween: 15 }
            }
          });
        }
      }

      // Init Splide - movies slider (exact original settings)
      if (window.Splide) {
        const moviesEl = document.getElementById('movies-slider');
        if (moviesEl) {
          if (moviesEl.splide) moviesEl.splide.destroy();
          new window.Splide('#movies-slider', {
            type: 'loop',
            drag: false,
            autoplay: true,
            perMove: 1,
            perPage: 6,
            arrows: false,
            pagination: false,
            interval: 850,
            pauseOnHover: false,
            easing: 'linear',
            gap: '20px',
            breakpoints: {
              768: { perPage: 2 },
              480: { perPage: 2 },
            }
          }).mount();
        }

        // Init Splide - sports slider (exact original settings)
        const sportsEl = document.getElementById('sports-slider');
        if (sportsEl) {
          if (sportsEl.splide) sportsEl.splide.destroy();
          new window.Splide('#sports-slider', {
            type: 'loop',
            drag: false,
            autoplay: true,
            perMove: 1,
            perPage: 6,
            arrows: false,
            pagination: false,
            interval: 850,
            pauseOnHover: false,
            easing: 'linear',
            gap: '20px',
            breakpoints: {
              768: { perPage: 2 },
              480: { perPage: 2 },
            }
          }).mount();
        }
      }

      // Pricing toggle (Standard / Multi-Screen)
      const toggleOptions = document.querySelectorAll('.pricing-toggle-option');
      const standardBlock = document.getElementById('pricing-standard');
      const multiscreenBlock = document.getElementById('pricing-multiscreen');

      function switchPricing(mode) {
        toggleOptions.forEach(function(opt) {
          opt.classList.toggle('active', opt.getAttribute('data-pricing') === mode);
        });
        if (standardBlock) standardBlock.classList.toggle('active', mode === 'standard');
        if (multiscreenBlock) multiscreenBlock.classList.toggle('active', mode === 'multiscreen');
      }

      toggleOptions.forEach(function(opt) {
        opt.addEventListener('click', function() {
          const mode = this.getAttribute('data-pricing');
          if (mode) switchPricing(mode);
        });
      });

      // Re-trigger jQuery plugins
      if (window.$ && window.$.fn.waypoint) {
        window.$(window).trigger('resize');
      }

    }, 300);

    return () => {
      clearTimeout(timer);
      delete window.trackAndRedirect;
    };
  }, []);

  return (
    <div dangerouslySetInnerHTML={{ __html: `<!--body overlay -->
    <div class="body-overlay"></div>
    
    <!--main content wrapper start-->
    <div class="main-wrapper">
        
        <!--header area start-->

        

    
        <!--header area end-->
        

        <!--hero section start-->
        <section class="hero-style-1">
            <div class="hero-area overflow-hidden position-relative zindex-1 bg-primary-gradient pt-90">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-7">
                            <div class="hero1-content-wrap">
                                <div class="review-area">
                                    
                                
                                    <img src="assets/img/brands/trust-pilot.svg" class="brand-logo pb-1" alt="trust pilot" />
                                    <a> <img src="assets/img/trustpilotstarsfr.svg" alt="star" class="star-rating mt-3 d-block" /> </a>
                                
                                </div>
                                
                                <div class="activation-badge">
                                    <span class="activation-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="18" height="18" fill="#ffffff"><path d="M240.5 224H352C365.3 224 376.3 232.9 379.5 245.8C382.7 258.7 377.7 272 366.5 279.9L159.1 423.9C148.5 431.5 133.8 431.7 122.1 424.4C110.4 417 104.5 403.2 106.9 389.8L128.5 288H16C2.692 288-8.269 279.1-11.47 266.2C-14.67 253.3-9.672 239.1 1.546 232.1L208.1 88.15C219.5 80.53 234.3 80.36 245.9 87.67C257.6 94.97 263.5 108.8 261.1 122.2L240.5 224z"/></svg>
                                    </span>
                                    <span class="activation-text">Activation Immédiate</span>
                                </div>

                                <h4 class="display-font mt-4">Offrant les meilleurs services <mark class="position-relative"> IPTV</mark> En Europe.</h4>
                                <p class="lead mt-4 text-hero-message">Profitez de votre temps avec une excellente qualité d’image allant jusqu’à 4K, sur n’importe quel appareil, à tout moment et n’importe où, avec plus de + 79 000 chaînes, plus de 249 000 VOD et un temps de disponibilité de 100%.<br class="d-none d-sm-inline-block"/> <mark class="text-warning"></mark></p>
                                <div class="mt-5 mb-1">
                                    <a href="#pricing" class="template-btn primary-btn mt-1 w-50 text-center text-white">Commencer</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="hero-right">
                                
                            </div>
                        </div>
                    </div>
                </div>
                <img src="assets/img/shapes/hero-right-top.png" alt="rectangle shape" class="right-top position-absolute" />
                <img src="assets/img/shapes/hero-right-bottom.svg" alt="rectangle shape" class="right-bottom position-absolute" />
            </div>
            <div class="promo-area light-bg">
                <div class="container">
                    <div class="row g-4 justify-content-center">
                        <div class="col-lg-4 col-md-6">
                            <div class="promo-item bg-white rounded primary-shadow">
                                <div class="promo-top d-flex align-items-center mb-3">
                                    <i class="fa-solid fa-tv-retro fa-2xl" style="color: #000000;"></i>
                                    <h6 class="ms-3 mb-0">79.000+ Chaînes du monde</h6>
                                </div>
                                <p class="mb-0">Une liste complète de toutes les chaînes européennes disponibles. Avec plus de 79 000 chaînes de télévision, nous pouvons vous offrir la liste de chaînes la plus avancée du marché</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <div class="promo-item bg-white rounded primary-shadow">
                                <div class="promo-top d-flex align-items-center mb-3">
                                    <i class="fa-solid fa-bolt fa-2xl" style="color: #000000;"></i>
                                    <h6 class="ms-3 mb-0">Connexion ultra-rapide</h6>
                                </div>
                                <p class="mb-0">Contrairement à d’autres fournisseurs d’IPTV, TVPLUX utilise un serveur dédié européen de haute qualité. L’ouverture de nos chaînes de télévision prendra moins de 0,5 seconde.</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <div class="promo-item bg-white rounded primary-shadow">
                                <div class="promo-top d-flex align-items-center mb-3">
                                    <i class="fa-solid fa-gear fa-2xl" style="color: #000000;"></i>
                                    <h6 class="ms-3 mb-0">Installation instantanée</h6>
                                </div>
                                <p class="mb-0">Vous pouvez facilement configurer et installer votre abonnement IPTV sur l'appareil de votre choix. Nous offrons une assistance complète après l'achat pour faciliter ce processus pour tout le monde.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
        <!--hero section end-->

        <!-- Offers Hero section (above pricing) -->
        <div class="container offers-hero-wrapper">
        <section class="offers-hero-section position-relative zindex-1">
            <div class="container p-2 pb-4">
                <div class="row align-items-center g-4 gy-5 overflow-visible">
                    <div class="col-lg-6 order-1 order-lg-1 overflow-visible">
                        <div class="offers-hero-content">
                            <div class="offers-hero-badge">
                                <i class="fa-solid fa-trophy"></i>
                                <span>Ligue 1 2026 · TVPLUX</span>
                            </div>
                            <h2 class="offers-hero-title">La Ligue 1 en 4K</h2>
                            <p class="offers-hero-subtitle">Regardez tous les matchs de la Ligue 1 en qualité 4K HDR sur tous vos appareils. Streaming instantané sans coupure.</p>
                            <div class="offers-hero-features">
                                <span class="offers-hero-feature-tag"><i class="fa-solid fa-play me-1"></i> Matchs & replays</span>
                                <span class="offers-hero-feature-tag"><i class="fa-solid fa-tv me-1"></i> 4K HDR</span>
                                <span class="offers-hero-feature-tag"><i class="fa-solid fa-bolt me-1"></i> Instantané</span>
                            </div>
                            <div class="hero-cta">
                                <a href="#pricing" class="template-btn hero-btn">
                                    <span class="icon">🎁</span>
                                    Voir les Offres
                                </a>
                                <span class="hero-trust">Satisfait ou Remboursé</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 order-2 order-lg-2">
                        <div class="offers-hero-images position-relative">
                            <div class="offers-hero-card-stack">
                                <div class="offers-hero-card offers-hero-card-1">
                                    <img src="assets/img/sports/ligue1logo.svg" alt="Ligue 1 Championnat de France" />
                                </div>
                                <div class="offers-hero-card offers-hero-card-2">
                                    <img src="assets/img/sports/ligue1d.jpg" alt="Ligue 1" />
                                </div>
                                <div class="offers-hero-card offers-hero-card-3">
                                    <img src="assets/img/sports/5.jpeg" alt="Euro 2024" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </div>
        <!-- Offers Hero end -->

        <section class="pricing-tab-section pricing-section-next light-bg pb-60 position-relative zindex-1 overflow-hidden">
            <img src="assets/img/shapes/line-red-top.png" alt="line shape" class="position-absolute right-top d-none d-lg-block" />
            <img src="assets/img/shapes/line-red.svg" alt="line shape" class="position-absolute left-bottom" />
            <div class="container" id='pricing' name="pricing">
                <div class="row justify-content-center">
                    <div class="col-lg-6">
                        <div class="section-heading text-center">
                            <h2>Découvrez nos meilleurs plans.</h2>
                        </div>

                              <!--ibo pro player Gift-->
                            <div class="hm7-custom-plan pt-30 overflow-hidden mb-1 ">
                                <div class="container">
                                    <div class="custom-plan-box position-relative zindex-1">
                                        <img src="assets/img/shapes/gift.png" alt="flower" class="position-absolute flower-shape zindex--1 soft-light" />
                                        <div class="row justify-content-center">
                                            <div class="col-lg-12">
                                                <div class="custom-plan-content text-center">
                                                    <h5 class="text-white mb-1 mr-3 ml-3"><i class="fa-solid fa-gift" style="margin-right: 8px;"></i> Activation Gratuite Pour L'application Ibo Pro Player 🎁</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--ibo pro player Gift end-->

                        <!-- Pricing toggle switch -->
                        <div class="pricing-toggle-wrapper mt-5">
                            <div class="pricing-toggle">
                                <span class="pricing-toggle-option active" data-pricing="standard">Standard</span>
                                <span class="pricing-toggle-option" data-pricing="multiscreen">Multi-Écrans</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pricing-wrapper position-relative zindex-1">
                    <img src="assets/img/shapes/frame.svg" alt="frame" class="position-absolute frame-shape" />

                    <!-- Standard pricing -->
                    <div id="pricing-standard" class="pricing-content-block active">
                    <div class="row pricing-cards-row g-4 justify-content-center mt-4">
                        <div class="col-lg-4 col-md-6">
                            <div class="pricing-column overflow-hidden position-relative bg-white rounded-10 deep-shadow">
                                <h3 class="h5">FORFAIT DE BASE -<br />12 MOIS</h3>
                                <span class="pricing-badge position-absolute rounded"><span class="gradient-txt">12 MOIS</span></span>
                                <span class="pricing-label d-block mt-4">Paiement unique :<br /> - Sans contrat contraignant</span>
                                <h4 class="h2 mt-2 monthly-price">29.00€<span> / 12 MOIS</span></h4>
                                <ul id="listnewbasic" class="feature-list mt-4">
                                    <li><span class="me-2"><i class="fa-solid fa-gift" style="color: #253fe9;"></i></span>IBO Pro Player Activé Gratuitement !</li>
                                    <li><span class="me-2"><i class="fa-solid fa-tv-retro" style="color: #253fe9;"></i></span>+79.000 Chaines, +249.000 Films et Séries.</li>
                                    <li><span class="me-2"><i class="fa-solid fa-popcorn" style="color: #253fe9;"></i></span>Netflix, Disney+, Amazon Prime Video, HBO Max, OCS, Paramount+, Apple+, Discovery+ , , </li>
                                    <li><span class="me-2"><i class="fa-solid fa-futbol" style="color: #253fe9;"></i></span>Ligue 1 Plus + France en FULL HD / 4K ⚽️</li>
                                    <li><span class="me-2"><i class="fa-sharp fa-solid fa-film" style="color: #253fe9;"></i></span>Choix illimité de Films & Séries</li>
                                    <li><span class="me-2"><i class="fa-solid fa-high-definition" style="color: #253fe9;"></i></span>Qualité SD / HD / FULL HD / 4K</li>
                                    <li><span class="me-2"><i class="fa-sharp fa-solid fa-clock-rotate-left" style="color: #253fe9;"></i></span>Catch-up et EPG</li>
                                    <li><span class="me-2"><i class="fa-solid fa-bolt" style="color: #253fe9;"></i></span>Serveurs Rapides Et Stables</li>
                                    <li><span class="me-2"><i class="fa-solid fa-gears" style="color: #253fe9;"></i></span>Compatible avec tous les appareils.</li>
                                    <li><span class="me-2"><i class="fa-solid fa-arrows-rotate" style="color: #253fe9;"></i></span>Contenu régulièrement mis à jour.</li>
                                    <li><span class="me-2"><i class="fa-solid fa-euro-sign" style="color: #253fe9;"></i></span>15 Jours Garantie De Remboursement.</li>
                                </ul>
                                <a onclick="trackAndRedirect('https://pluxlink.ink/dashboard/api/link.php?id=1')" class="btn template-btn secondary-btn w-100 text-center mt-40">Commander maintenant</a>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <div class="pricing-column overflow-hidden position-relative bg-white rounded-10 deep-shadow">
                                <h3 class="h5">FORFAIT <br />- PREMIUM <br />- 12 MOIS<br /> + 3 MOIS GRATUIT</h3>
                                <span class="popular-badge position-absolute text-center fw-bold">LE PLUS POPULAIRE</span>
                                <span class="pricing-label d-block mt-4">Paiement unique :<br /> - Sans contrat contraignant</span>
                                <h4 class="h2 mt-2 monthly-price">39.00€<span> /  15 MOIS</span></h4>
                                <ul id="listnew" class="feature-list mt-4">
                                    <li><span class="me-2"><i class="fa-solid fa-gift" style="color: #253fe9;"></i></span>IBO Pro Player Activé Gratuitement !</li>
                                    <li><span class="me-2"><i class="fa-solid fa-xmarks-lines" style="color: #253fe9;"></i></span>Chaînes + Films Pour Adultes (avec mot de passe) 🔞</li>
                                    <li><span class="me-2"><i class="fa-solid fa-tv-retro" style="color: #253fe9;"></i></span>+79.000 Chaines, +249.000 Films et Séries.</li>
                                    <li><span class="me-2"><i class="fa-solid fa-popcorn" style="color: #253fe9;"></i></span>Netflix, Disney+, Amazon Prime Video, HBO Max, OCS, Paramount+, Apple+, Discovery+ , , </li>
                                    <li><span class="me-2"><i class="fa-solid fa-futbol" style="color: #253fe9;"></i></span>Ligue 1 Plus + France en FULL HD / 4K ⚽️</li>
                                    <li><span class="me-2"><i class="fa-sharp fa-solid fa-film" style="color: #253fe9;"></i></span>Choix illimité de Films & Séries</li>
                                    <li><span class="me-2"><i class="fa-solid fa-high-definition" style="color: #253fe9;"></i></span>Qualité SD / HD / FULL HD / 4K</li>
                                    <li><span class="me-2"><i class="fa-sharp fa-solid fa-clock-rotate-left" style="color: #253fe9;"></i></span>Catch-up et EPG</li>
                                    <li><span class="me-2"><i class="fa-solid fa-bolt" style="color: #253fe9;"></i></span>Serveurs Rapides Et Stables</li>
                                    <li><span class="me-2"><i class="fa-solid fa-gears" style="color: #253fe9;"></i></span>Compatible avec tous les appareils.</li>
                                    <li><span class="me-2"><i class="fa-solid fa-arrows-rotate" style="color: #253fe9;"></i></span>Contenu régulièrement mis à jour.</li>
                                    <li><span class="me-2"><i class="fa-solid fa-euro-sign" style="color: #253fe9;"></i></span>15 Jours Garantie De Remboursement.</li>
                                </ul>
                                <a onclick="trackAndRedirect('https://pluxlink.ink/dashboard/api/link.php?id=2')" class="btn template-btn primary-btn w-100 mt-40 text-center">Commander maintenant</a>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <div class="pricing-column overflow-hidden position-relative bg-white rounded-10 deep-shadow">
                                <h3 class="h5">FORFAIT GOLD <br /> - 15 MOIS <br />📺 📺  2 écrans</h3>
                                <span class="popular-badge position-absolute text-center fw-bold">MEILLEUR PRIX</span>
                                <span class="pricing-label d-block mt-4">Paiement unique :<br /> - Sans contrat contraignant</span>
                                <h4 class="h2 mt-2 monthly-price">49.00€<span> / 15 MOIS</span></h4>
                                <ul id="listnew" class="feature-list mt-4">
                                    <li><span class="me-2"><i class="fa-solid fa-gift" style="color: #253fe9;"></i></span>IBO Pro Player Activé Gratuitement !</li>
                                    <li><span class="me-2"><i class="fa-solid fa-tv fa" style="color: #253fe9;"></i> <i class="fa-solid fa-tv" style="color: #253fe9;"></i></span>  Deux écrans actifs</li>
                                    <li><span class="me-2"><i class="fa-solid fa-xmarks-lines" style="color: #253fe9;"></i></span>Chaînes + Films Pour Adultes (avec mot de passe) 🔞</li>
                                    <li><span class="me-2"><i class="fa-solid fa-tv-retro" style="color: #253fe9;"></i></span>+79.000 Chaines, +249.000 Films et Séries.</li>
                                    <li><span class="me-2"><i class="fa-solid fa-popcorn" style="color: #253fe9;"></i></span>Netflix, Disney+, Amazon Prime Video, HBO Max, OCS, Paramount+, Apple+, Discovery+ , , </li>
                                    <li><span class="me-2"><i class="fa-solid fa-futbol" style="color: #253fe9;"></i></span>Ligue 1 Plus + France en FULL HD / 4K ⚽️</li>
                                    <li><span class="me-2"><i class="fa-sharp fa-solid fa-film" style="color: #253fe9;"></i></span>Choix illimité de Films & Séries</li>
                                    <li><span class="me-2"><i class="fa-solid fa-high-definition" style="color: #253fe9;"></i></span>Qualité SD / HD / FULL HD / 4K</li>
                                    <li><span class="me-2"><i class="fa-sharp fa-solid fa-clock-rotate-left" style="color: #253fe9;"></i></span>Catch-up et EPG</li>
                                    <li><span class="me-2"><i class="fa-solid fa-bolt" style="color: #253fe9;"></i></span>Serveurs Rapides Et Stables</li>
                                    <li><span class="me-2"><i class="fa-solid fa-gears" style="color: #253fe9;"></i></span>Compatible avec tous les appareils.</li>
                                    <li><span class="me-2"><i class="fa-solid fa-arrows-rotate" style="color: #253fe9;"></i></span>Contenu régulièrement mis à jour.</li>
                                    <li><span class="me-2"><i class="fa-solid fa-euro-sign" style="color: #253fe9;"></i></span>15 Jours Garantie De Remboursement.</li>
                                </ul>
                                <a onclick="trackAndRedirect('https://pluxlink.ink/dashboard/api/link.php?id=3')" class="btn template-btn primary-btn w-100 mt-40 text-center">Commander maintenant</a>
                            </div>
                        </div>
                    </div>
                    <div class="row g-4 mt-4 justify-content-center">
                        <div class="col-lg-4 col-md-6">
                            <div class="pricing-column pricing-column-lifetime position-relative bg-white rounded-10 deep-shadow">
                                <h3 class="h5">FORFAIT À VIE</h3>
                                <span class="pricing-badge position-absolute rounded"><span class="gradient-txt">À VIE</span></span>
                                <span class="pricing-label d-block mt-4">Paiement unique :<br /> - Sans contrat contraignant <br /> - Accès à vie</span>
                                <h4 class="h2 mt-2 monthly-price">129.00€<span> / À VIE</span></h4>
                                <ul class="feature-list mt-4">
                                    <li><span class="me-2"><i class="fa-solid fa-gift" style="color: #ffffff;"></i></span>IBO Pro Player Activé Gratuitement !</li>
                                    <li><span class="me-2"><i class="fa-solid fa-infinity" style="color: #ffffff;"></i></span>Accès illimité à vie</li>
                                    <li><span class="me-2"><i class="fa-solid fa-xmarks-lines" style="color: #ffffff;"></i></span>Chaînes + Films Pour Adultes (avec mot de passe) 🔞</li>
                                    <li><span class="me-2"><i class="fa-solid fa-tv-retro" style="color: #ffffff;"></i></span>2 Écrans simultanés</li>
                                    <li><span class="me-2"><i class="fa-solid fa-popcorn" style="color: #ffffff;"></i></span>Accès complet au Forfait PREMIUM</li>
                                    <li><span class="me-2"><i class="fa-solid fa-futbol" style="color: #ffffff;"></i></span>30 Jours Garantie De Remboursement</li>
                                </ul>
                                <a onclick="trackAndRedirect('https://pluxlink.ink/dashboard/api/link.php?id=7')" class="btn template-btn primary-btn lifetime-cta-btn w-100 text-center mt-30">Commander maintenant</a>
                            </div>
                        </div>
                    </div>
                    </div>
                    <!-- Standard pricing end -->

                    <!-- Multi-Screen pricing (shown when Multi-Screen toggle selected) -->
                    <div id="pricing-multiscreen" class="pricing-content-block">
                        <div class="row pricing-cards-row g-4 justify-content-center mt-4">
                            <div class="col-lg-4 col-md-6">
                                <div class="pricing-column overflow-hidden position-relative bg-white rounded-10 deep-shadow">
                                    <h3 class="h5">FORFAIT DIAMANT –<br />2 ANS</h3>
                                    <span class="pricing-badge position-absolute rounded"><span class="gradient-txt">2 ANS</span></span>
                                    <span class="pricing-label d-block mt-4">Paiement unique :<br /> - Sans contrat contraignant</span>
                                    <h4 class="h2 mt-2 monthly-price">59.00€<span> / 2 ANS</span></h4>
                                    <ul id="listnew" class="feature-list mt-4">
                                        <li><span class="me-2"><i class="fa-solid fa-gift" style="color: #253fe9;"></i></span>IBO Pro Player Activé Gratuitement !</li>
                                        <li><span class="me-2"><i class="fa-solid fa-tv" style="color: #253fe9;"></i> <i class="fa-solid fa-tv" style="color: #253fe9;"></i></span>Deux écrans actifs</li>
                                        <li><span class="me-2"><i class="fa-solid fa-xmarks-lines" style="color: #253fe9;"></i></span>Chaînes + Films Pour Adultes (avec mot de passe) 🔞</li>
                                        <li><span class="me-2"><i class="fa-solid fa-tv-retro" style="color: #253fe9;"></i></span>+79.000 Chaines, +249.000 Films et Séries.</li>
                                        <li><span class="me-2"><i class="fa-solid fa-popcorn" style="color: #253fe9;"></i></span>Netflix, Disney+, Amazon Prime Video, HBO Max, OCS, Paramount+, Apple+, Discovery+ , , </li>
                                        <li><span class="me-2"><i class="fa-solid fa-futbol" style="color: #253fe9;"></i></span>Ligue 1 Plus + France en FULL HD / 4K ⚽️</li>
                                        <li><span class="me-2"><i class="fa-sharp fa-solid fa-film" style="color: #253fe9;"></i></span>Choix illimité de Films & Séries</li>
                                        <li><span class="me-2"><i class="fa-solid fa-high-definition" style="color: #253fe9;"></i></span>Qualité SD / HD / FULL HD / 4K</li>
                                        <li><span class="me-2"><i class="fa-sharp fa-solid fa-clock-rotate-left" style="color: #253fe9;"></i></span>Catch-up et EPG</li>
                                        <li><span class="me-2"><i class="fa-solid fa-bolt" style="color: #253fe9;"></i></span>Serveurs Rapides Et Stables</li>
                                        <li><span class="me-2"><i class="fa-solid fa-gears" style="color: #253fe9;"></i></span>Compatible avec tous les appareils.</li>
                                        <li><span class="me-2"><i class="fa-solid fa-arrows-rotate" style="color: #253fe9;"></i></span>Contenu régulièrement mis à jour.</li>
                                        <li><span class="me-2"><i class="fa-solid fa-euro-sign" style="color: #253fe9;"></i></span>15 Jours Garantie De Remboursement.</li>
                                    </ul>
                                    <a onclick="trackAndRedirect('https://pluxlink.ink/dashboard/api/link.php?id=4')" class="btn template-btn secondary-btn w-100 text-center mt-40">Commander maintenant</a>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="pricing-column overflow-hidden position-relative bg-white rounded-10 deep-shadow">
                                    <h3 class="h5">FORFAIT FAMILIAL –<br />3 ÉCRANS</h3>
                                    <span class="popular-badge position-absolute text-center fw-bold">LE PLUS POPULAIRE</span>
                                    <span class="pricing-label d-block mt-4">Paiement unique :<br /> - Sans contrat contraignant</span>
                                    <h4 class="h2 mt-2 monthly-price">69.00€<span> / 18 MOIS</span></h4>
                                    <ul id="listnew" class="feature-list mt-4">
                                        <li><span class="me-2"><i class="fa-solid fa-gift" style="color: #253fe9;"></i></span>IBO Pro Player Activé Gratuitement !</li>
                                        <li><span class="me-2"><i class="fa-solid fa-tv" style="color: #253fe9;"></i> <i class="fa-solid fa-tv" style="color: #253fe9;"></i> <i class="fa-solid fa-tv" style="color: #253fe9;"></i></span>Trois écrans actifs</li>
                                        <li><span class="me-2"><i class="fa-solid fa-xmarks-lines" style="color: #253fe9;"></i></span>Chaînes + Films Pour Adultes (avec mot de passe) 🔞</li>
                                        <li><span class="me-2"><i class="fa-solid fa-tv-retro" style="color: #253fe9;"></i></span>+79.000 Chaines, +249.000 Films et Séries.</li>
                                        <li><span class="me-2"><i class="fa-solid fa-popcorn" style="color: #253fe9;"></i></span>Netflix, Disney+, Amazon Prime Video, HBO Max, OCS, Paramount+, Apple+, Discovery+ , , </li>
                                        <li><span class="me-2"><i class="fa-solid fa-futbol" style="color: #253fe9;"></i></span>Ligue 1 Plus + France en FULL HD / 4K ⚽️</li>
                                        <li><span class="me-2"><i class="fa-sharp fa-solid fa-film" style="color: #253fe9;"></i></span>Choix illimité de Films & Séries</li>
                                        <li><span class="me-2"><i class="fa-solid fa-high-definition" style="color: #253fe9;"></i></span>Qualité SD / HD / FULL HD / 4K</li>
                                        <li><span class="me-2"><i class="fa-sharp fa-solid fa-clock-rotate-left" style="color: #253fe9;"></i></span>Catch-up et EPG</li>
                                        <li><span class="me-2"><i class="fa-solid fa-bolt" style="color: #253fe9;"></i></span>Serveurs Rapides Et Stables</li>
                                        <li><span class="me-2"><i class="fa-solid fa-gears" style="color: #253fe9;"></i></span>Compatible avec tous les appareils.</li>
                                        <li><span class="me-2"><i class="fa-solid fa-arrows-rotate" style="color: #253fe9;"></i></span>Contenu régulièrement mis à jour.</li>
                                        <li><span class="me-2"><i class="fa-solid fa-euro-sign" style="color: #253fe9;"></i></span>15 Jours Garantie De Remboursement.</li>
                                    </ul>
                                    <a onclick="trackAndRedirect('https://pluxlink.ink/dashboard/api/link.php?id=5')" class="btn template-btn primary-btn w-100 mt-40 text-center">Commander maintenant</a>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="pricing-column overflow-hidden position-relative bg-white rounded-10 deep-shadow">
                                    <h3 class="h5">FORFAIT FAMILIAL –<br />4 ÉCRANS</h3>
                                    <span class="popular-badge position-absolute text-center fw-bold">MEILLEUR PRIX</span>
                                    <span class="pricing-label d-block mt-4">Paiement unique :<br /> - Sans contrat contraignant</span>
                                    <h4 class="h2 mt-2 monthly-price">89.00€<span> / 18 MOIS</span></h4>
                                    <ul id="listnew" class="feature-list mt-4">
                                        <li><span class="me-2"><i class="fa-solid fa-gift" style="color: #253fe9;"></i></span>IBO Pro Player Activé Gratuitement !</li>
                                        <li><span class="me-2"><i class="fa-solid fa-tv" style="color: #253fe9;"></i> <i class="fa-solid fa-tv" style="color: #253fe9;"></i> <i class="fa-solid fa-tv" style="color: #253fe9;"></i> <i class="fa-solid fa-tv" style="color: #253fe9;"></i></span>Quatre écrans actifs</li>
                                        <li><span class="me-2"><i class="fa-solid fa-xmarks-lines" style="color: #253fe9;"></i></span>Chaînes + Films Pour Adultes (avec mot de passe) 🔞</li>
                                        <li><span class="me-2"><i class="fa-solid fa-tv-retro" style="color: #253fe9;"></i></span>+79.000 Chaines, +249.000 Films et Séries.</li>
                                        <li><span class="me-2"><i class="fa-solid fa-popcorn" style="color: #253fe9;"></i></span>Netflix, Disney+, Amazon Prime Video, HBO Max, OCS, Paramount+, Apple+, Discovery+ , , </li>
                                        <li><span class="me-2"><i class="fa-solid fa-futbol" style="color: #253fe9;"></i></span>Ligue 1 Plus + France en FULL HD / 4K ⚽️</li>
                                        <li><span class="me-2"><i class="fa-sharp fa-solid fa-film" style="color: #253fe9;"></i></span>Choix illimité de Films & Séries</li>
                                        <li><span class="me-2"><i class="fa-solid fa-high-definition" style="color: #253fe9;"></i></span>Qualité SD / HD / FULL HD / 4K</li>
                                        <li><span class="me-2"><i class="fa-sharp fa-solid fa-clock-rotate-left" style="color: #253fe9;"></i></span>Catch-up et EPG</li>
                                        <li><span class="me-2"><i class="fa-solid fa-bolt" style="color: #253fe9;"></i></span>Serveurs Rapides Et Stables</li>
                                        <li><span class="me-2"><i class="fa-solid fa-gears" style="color: #253fe9;"></i></span>Compatible avec tous les appareils.</li>
                                        <li><span class="me-2"><i class="fa-solid fa-arrows-rotate" style="color: #253fe9;"></i></span>Contenu régulièrement mis à jour.</li>
                                        <li><span class="me-2"><i class="fa-solid fa-euro-sign" style="color: #253fe9;"></i></span>15 Jours Garantie De Remboursement.</li>
                                    </ul>
                                    <a onclick="trackAndRedirect('https://pluxlink.ink/dashboard/api/link.php?id=6')" class="btn template-btn primary-btn w-100 mt-40 text-center">Commander maintenant</a>
                                </div>
                            </div>
                        </div>
                        <div class="row g-4 mt-4 justify-content-center">
                            <div class="col-lg-4 col-md-6">
                                <div class="pricing-column pricing-column-lifetime position-relative bg-white rounded-10 deep-shadow">
                                    <h3 class="h5">FORFAIT À VIE</h3>
                                    <span class="pricing-badge position-absolute rounded"><span class="gradient-txt">À VIE</span></span>
                                    <span class="pricing-label d-block mt-4">Paiement unique :<br /> - Accès à vie</span>
                                    <h4 class="h2 mt-2 monthly-price">129.00€<span> / À VIE</span></h4>
                                    <ul class="feature-list mt-4">
                                        <li><span class="me-2"><i class="fa-solid fa-gift" style="color: #ffffff;"></i></span>IBO Pro Player Activé Gratuitement !</li>
                                    <li><span class="me-2"><i class="fa-solid fa-infinity" style="color: #ffffff;"></i></span>Accès illimité à vie</li>
                                    <li><span class="me-2"><i class="fa-solid fa-xmarks-lines" style="color: #ffffff;"></i></span>Chaînes + Films Pour Adultes (avec mot de passe) 🔞</li>
                                    <li><span class="me-2"><i class="fa-solid fa-tv-retro" style="color: #ffffff;"></i></span>2 Écrans simultanés</li>
                                    <li><span class="me-2"><i class="fa-solid fa-popcorn" style="color: #ffffff;"></i></span>Accès complet au Forfait PREMIUM</li>
                                    <li><span class="me-2"><i class="fa-solid fa-futbol" style="color: #ffffff;"></i></span>30 Jours Garantie De Remboursement</li>
                                        
                                    </ul>
                                    <a onclick="trackAndRedirect('https://pluxlink.ink/dashboard/api/link.php?id=7')" class="btn template-btn primary-btn lifetime-cta-btn w-100 text-center mt-30">Commander maintenant</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Multi-Screen pricing end -->

                </div>
            </div>
            
        </section>
        <!--pricing section end-->
        
       <!--custom plan start-->
       <div class="hm7-custom-plan pt-20 overflow-hidden mb-4">
        <div class="container">
            <div class="custom-plan-box position-relative zindex-1">
                <img src="assets/img/shapes/flower.png" alt="flower" class="position-absolute flower-shape zindex--1 soft-light" />
                <div class="row justify-content-center">
                    <div class="col-lg-6">
                        <div class="custom-plan-content text-center">
                            <h3 class="text-white mb-3">Options d'abonnement personnalisables</h3>
                            <p class="mb-30 text-white">Nous proposons des abonnements IPTV adaptés à chaque besoin. Besoin d'une autre option ? Contactez-nous et nous créerons un abonnement sur mesure pour vous.</p>
                            <a href="https://wa.me/33756756461" class="template-btn rs-primary-btn" style="font-weight: bold; font-size: 16px;"><i class="fa-brands fa-whatsapp fa-lg" style="margin-right: 8px;"></i> Contactez-nous</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--custom plan end-->


       
        <!--channels area start-->
<section class="application-area light-bg pb-120 position-relative zindex-1 overflow-hidden">
    <img src="assets/img/shapes/box-shape.png" alt="box-shape" class="position-absolute left-bottom" />
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-7">
                <div class="section-title text-center">
                    <h2>Diffusion illimitée des derniers films, séries et variantes de chaînes en direct.</h2>
                </div>
            </div>
        </div>

         <div class="splide mt-5" id="movies-slider">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide"><img src="assets/img/mvs/postermv1.webp" alt="Slide 9" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv2.webp" alt="Slide 10" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv3.webp" alt="Slide 11" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv4.webp" alt="Slide 11" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv5.webp" alt="Slide 11" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv6.webp" alt="Slide 1" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv7.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv8.webp" alt="Slide 3" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv9.webp" alt="Slide 4" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv10.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv11.webp" alt="Slide 1" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv12.webp" alt="Slide 5" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv13.webp" alt="Slide 5" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv14.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv15.webp" alt="Slide 6" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv16.webp" alt="Slide 7" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv17.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv18.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv19.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv20.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv21.webp" alt="Slide 7" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv22.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv23.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv24.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv25.jpg" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv26.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv27.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv28.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv29.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv30.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv31.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv32.webp" alt="Slide 8" /></li>
                    <li class="splide__slide"><img src="assets/img/mvs/postermv33.webp" alt="Slide 8" /></li>



                </ul>
            </div>
        </div>


         


        <div class="app_lists mt-5">
            <div class="row g-4 justify-content-center">
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/daz.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/netfli.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/Prime.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/disn.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/canalpluss.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/beinsport.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/tf1.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/hbomax.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/w9.svg" alt="joomla" class="img-fluid flex-shrink-0" />                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/OCS.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/pluto.svg" alt="joomla" class="img-fluid flex-shrink-0" />                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                    <img src="assets/img/brands/mbc.svg" alt="joomla" class="img-fluid flex-shrink-0" />                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/rmc.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/m6.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/tfs.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/Hulu.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/arte.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/appletvplus.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
<!--channels area end-->

 <!--Sports area start-->
 <section class="application-area light-bg pb-120 position-relative zindex-1 overflow-hidden">
    <img src="assets/img/shapes/box-shape.png" alt="box-shape" class="position-absolute left-bottom" />
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-7">
                <div class="section-title text-center">
                    <h2>Découvrez tous les canaux sportifs et vos compétitions préférées dans un seul abonnement.</h2>
                </div>
            </div>
        </div>



         <div class="splide mt-5" id="sports-slider">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide"><img src="assets/img/sports/2.jpeg" alt="Slide 9" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/6.webp" alt="Slide 10" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/5.jpeg" alt="Slide 11" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/ufc.jpg" alt="Slide 11" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/euro24.jpg" alt="Slide 1" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/motogp.jpg" alt="Slide 1" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/4.jpeg" alt="Slide 11" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/2.jpeg" alt="Slide 11" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/f1poster2.jpeg" alt="Slide 1" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/eredivisieposter.jpeg" alt="Slide 1" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/nascarsports.jpg" alt="Slide 1" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/tennis.jpg" alt="Slide 1" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/peremierleague.jpg" alt="Slide 1" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/championsleague02.jpg" alt="Slide 1" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/seriaitaly.webp" alt="Slide 1" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/ligue1d.jpg" alt="Slide 1" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/afcon25.webp" alt="Slide 1" /></li>
                    <li class="splide__slide"><img src="assets/img/sports/f1poster.jpg" alt="Slide 1" /></li>

                </ul>
            </div>
        </div>

 <!--Sports area end-->


        <div class="app_lists mt-5">
            <div class="row g-4 justify-content-center">
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/ligue1svg.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/ligue2.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/Premier League.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/Champions.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/Europa League.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/Laliga.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/Seria A.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/Jupiler Pro.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/Bundesliga.svg" alt="joomla" class="img-fluid flex-shrink-0" />                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/f1.svg" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/RSL.svg" alt="joomla" class="img-fluid flex-shrink-0" />                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                    <img src="assets/img/brands/Ligaportugal.svg" alt="joomla" class="img-fluid flex-shrink-0" />                    </div>
                </div>
                
            </div>

        </div>
    </div>
</section>
<!--Lueage area end-->

 <!-- Support -->
  <!--
 <div class="host-fs-support-area pt-30 pb-30">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-6">
                <div class="text-center">
                    <h2 class="host-fs-title text-black fs-48 fw-800">Bereik Ons op Uw Voorkeursplatform</h2>
                    <p class="mb-30">
                        Ons team is bereikbaar via WhatsApp, Telegram en e-mail. Kies uw favoriete platform en ervaar onze snelle, naadloze ondersteuning.</p>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-xxl-10">
                <div class="position-relative z-1s">
                    <div class="row">
                        <div class="col-lg-4 col-md-6">
                            <div class="isb-support-box bg-white text-center ptb-50 rounded-12 mt-20">
                                <i class="isb-support-image fa-brands fa-whatsapp fa-2xl" style="color: #63E6BE;"></i>
                                <h6 class="text-black mt-20">WhatsApp</h6>
                                <p class="fs-14 text-black">@tvnexu</p>
                                <a href="https://wa.me/+3197010266890" class="btn isb-small-btn fs-hover-style fs-hover-style text-black border-dark mt-10">Neem Contact Op</a>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <div class="isb-support-box bg-white text-center ptb-50 rounded-12 mt-20">
                                <i class="isb-support-image fa-brands fa-telegram fa-2xl" style="color: #74C0FC;"></i>
                                <h6 class="text-black mt-20">Telegram</h6>
                                <p class="fs-14 text-black">@tvnexu</p>
                                <a href="" class="btn isb-small-btn fs-hover-style fs-hover-style text-black border-dark mt-10">Neem Contact Op</a>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <div class="isb-support-box bg-white text-center ptb-50 rounded-12 mt-20">
                                <i class="isb-support-image fa-solid fa-envelope fa-2xl"></i>
                                <h6 class="text-black mt-20">Email</h6>
                                <p class="fs-14 text-black">contact@tvnexu.com</p>
                                <a href="" class="btn isb-small-btn fs-hover-style fs-hover-style text-black border-dark mt-10">Neem Contact Op</a>
                            </div>
                        </div>
                    </div>
                    <img class="position-absolute shape-1 isb-rotate-animation img-fluid z--1" src="assets/img/home_19/shape/support.png" alt="" />
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- Support -->

<!--feedback area start-->
<section class="hm2-feedback pt-120 pb-120 overflow-hidden">
    <div class="container position-relative zindex-1">
        <img src="assets/img/shapes/feedback-circle.svg" alt="circle" class="position-absolute feedback-circle d-none d-md-block" />
        <div class="row g-5">
            <div class="col-lg-5">
                <div class="hm2-feedback-left text-center text-lg-start">
                    <img src="assets/img/star-5.svg" alt="star rating" class="img-fluid d-block m-auto m-lg-0" />
                    <span class="text-small mt-2 d-block">4,4 sur 5 basé sur +270 avis.</span>
                    <div class="section-title mt-4">
                        <h2 class="mb-3">Avis de nos chers<br /> clients.</h2>
                        <p>Découvrez ce que nos clients disent de la qualité de nos services et de notre assistance.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-7">
                <div class="hm2-feedback-right position-relative">
                    <div class="gradient-bg"></div>
                    <div class="hm2-feedback-slider card__content_feed swiper">
                        <div class="swiper-wrapper">
                            <article class="hm2-feedback-item bg-white position-relative swiper-slide">
                                <img src="assets/img/star-5.svg" alt="star rating" class="img-fluid" /><br />
                                <div class="align-items-center align-item-center">
                                    <img src="assets/img/reviewimg/francereview01.webp" alt="joomla" class="img-fluid text-center align-item-centers flex-shrink-0 m-3" />
                                </div>                                
                                <p class="quote-text mb-30 mt-4">"Je suis très satisfait, tant en termes de stabilité que de service client."</p>
                                <div class="clients-info d-flex align-items-center">
                                    <div class="clients-designation ms-3">
                                        <h6 class="mb-1">Pierre Dupont</h6>
                                        <span>Paris</span>
                                    </div>
                                </div>
                                <span class="quote-icon position-absolute text-center rounded-circle text-white">
                                  <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path opacity="0.8" d="M19.25 17.5L17.5 21L21 21C24.8675 21 28 16.1175 28 12.25L28 1.90735e-06L15.75 8.3642e-07L15.75 12.25L22.75 12.25C22.75 17.5 19.25 17.5 19.25 17.5ZM7 12.25C7 17.5 3.5 17.5 3.5 17.5L1.75 21L5.25 21C9.1175 21 12.25 16.1175 12.25 12.25L12.25 5.3044e-07L-7.14705e-08 -5.40489e-07L-1.1424e-06 12.25L7 12.25Z" fill="white"/>
                                  </svg>
                              </span>
                            </article>

                            <article class="hm2-feedback-item bg-white position-relative swiper-slide">
                                <img src="assets/img/star-5.svg" alt="star rating" class="img-fluid" /><br />
                                <div class="align-items-center align-item-center">
                                    <img src="assets/img/reviewimg/francereview02.webp" alt="joomla" class="img-fluid text-center align-item-centers flex-shrink-0 m-3" />
                                </div>                                
                                <p class="quote-text mb-30 mt-4"> 
                                    "Très bon IPTV et sav au top."</p>
                                <div class="clients-info d-flex align-items-center">
                                    <div class="clients-designation ms-3">
                                        <h6 class="mb-1">Julien Moreau</h6>
                                        <span>Lyon</span>
                                    </div>
                                </div>
                                <span class="quote-icon position-absolute text-center rounded-circle text-white">
                                  <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path opacity="0.8" d="M19.25 17.5L17.5 21L21 21C24.8675 21 28 16.1175 28 12.25L28 1.90735e-06L15.75 8.3642e-07L15.75 12.25L22.75 12.25C22.75 17.5 19.25 17.5 19.25 17.5ZM7 12.25C7 17.5 3.5 17.5 3.5 17.5L1.75 21L5.25 21C9.1175 21 12.25 16.1175 12.25 12.25L12.25 5.3044e-07L-7.14705e-08 -5.40489e-07L-1.1424e-06 12.25L7 12.25Z" fill="white"/>
                                  </svg>
                              </span>
                            </article>

                            <article class="hm2-feedback-item bg-white position-relative swiper-slide">
                                <img src="assets/img/star-5.svg" alt="star rating" class="img-fluid" /><br />
                                <div class="align-items-center align-item-center">
                                    <img src="assets/img/reviewimg/francereview03.webp" alt="joomla" class="img-fluid text-center align-item-centers flex-shrink-0 m-3" />
                                </div>                                
                                <p class="quote-text mb-30 mt-4"> "Service clients réactif toujours à l'écoute,et efficace très bon service je recommande,sans problème."</p>
                                <div class="clients-info d-flex align-items-center">
                                    <div class="clients-designation ms-3">
                                        <h6 class="mb-1">Lucas Lefèvre –</h6>
                                        <span>Bordeaux</span>
                                    </div>
                                </div>
                                <span class="quote-icon position-absolute text-center rounded-circle text-white">
                                  <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path opacity="0.8" d="M19.25 17.5L17.5 21L21 21C24.8675 21 28 16.1175 28 12.25L28 1.90735e-06L15.75 8.3642e-07L15.75 12.25L22.75 12.25C22.75 17.5 19.25 17.5 19.25 17.5ZM7 12.25C7 17.5 3.5 17.5 3.5 17.5L1.75 21L5.25 21C9.1175 21 12.25 16.1175 12.25 12.25L12.25 5.3044e-07L-7.14705e-08 -5.40489e-07L-1.1424e-06 12.25L7 12.25Z" fill="white"/>
                                  </svg>
                              </span>
                            </article>
                            <article class="hm2-feedback-item bg-white position-relative swiper-slide">
                                <img src="assets/img/star-5.svg" alt="star rating" class="img-fluid" /><br />
                                <img src="assets/img/reviewimg/francereview04.webp" alt="joomla" class="img-fluid flex-shrink-0 m-3" />
                                <p class="quote-text mb-30 mt-4"> "Très bon contact pour l’inscription. Très réactif pour répondre. Les contenus sont de qualité et très complets. Rien à dire pour le moment. Je recommande."</p>
                                <div class="clients-info d-flex align-items-center">
                                    <div class="clients-designation ms-3">
                                        <h6 class="mb-1">Lucas Janssens</h6>
                                        <span>Brussels</span>
                                    </div>
                                </div>
                                <span class="quote-icon position-absolute text-center rounded-circle text-white">
                                  <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path opacity="0.8" d="M19.25 17.5L17.5 21L21 21C24.8675 21 28 16.1175 28 12.25L28 1.90735e-06L15.75 8.3642e-07L15.75 12.25L22.75 12.25C22.75 17.5 19.25 17.5 19.25 17.5ZM7 12.25C7 17.5 3.5 17.5 3.5 17.5L1.75 21L5.25 21C9.1175 21 12.25 16.1175 12.25 12.25L12.25 5.3044e-07L-7.14705e-08 -5.40489e-07L-1.1424e-06 12.25L7 12.25Z" fill="white"/>
                                  </svg>
                              </span>
                            </article>
                            <article class="hm2-feedback-item bg-white position-relative swiper-slide">
                                <img src="assets/img/star-5.svg" alt="star rating" class="img-fluid" /><br />
                                <img src="assets/img/reviewimg/francereview05.webp" alt="joomla" class="img-fluid flex-shrink-0 m-3" />                                
                                <p class="quote-text mb-30 mt-4"> "Les contenus sont de très bonnes qualités et il y a un large choix avec des mises à jours constantes ! Si vous avez des soucis le service client èst très réactif "</p>
                                <div class="clients-info d-flex align-items-center">
                                    <div class="clients-designation ms-3">
                                        <h6 class="mb-1">Hugo Richard</h6>
                                        <span>Strasbourg</span>
                                    </div>
                                </div>
                                <span class="quote-icon position-absolute text-center rounded-circle text-white">
                                  <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path opacity="0.8" d="M19.25 17.5L17.5 21L21 21C24.8675 21 28 16.1175 28 12.25L28 1.90735e-06L15.75 8.3642e-07L15.75 12.25L22.75 12.25C22.75 17.5 19.25 17.5 19.25 17.5ZM7 12.25C7 17.5 3.5 17.5 3.5 17.5L1.75 21L5.25 21C9.1175 21 12.25 16.1175 12.25 12.25L12.25 5.3044e-07L-7.14705e-08 -5.40489e-07L-1.1424e-06 12.25L7 12.25Z" fill="white"/>
                                  </svg>
                              </span>
                            </article>
                            <article class="hm2-feedback-item bg-white position-relative swiper-slide">
                                <img src="assets/img/star-5.svg" alt="star rating" class="img-fluid" /><br />
                                <img src="assets/img/reviewimg/francereview06.webp" alt="joomla" class="img-fluid flex-shrink-0 m-3" />                                
                                <p class="quote-text mb-30 mt-4"> "Tvplux très rassurant , Satisfait de l’application, Avec plusieurs chaînes ,des films et des séries"</p>
                                <div class="clients-info d-flex align-items-center">
                                    <div class="clients-designation ms-3">
                                        <h6 class="mb-1">Ahamad Lamine DIABY</h6>
                                        <span>Nice</span>
                                    </div>
                                </div>
                                <span class="quote-icon position-absolute text-center rounded-circle text-white">
                                  <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path opacity="0.8" d="M19.25 17.5L17.5 21L21 21C24.8675 21 28 16.1175 28 12.25L28 1.90735e-06L15.75 8.3642e-07L15.75 12.25L22.75 12.25C22.75 17.5 19.25 17.5 19.25 17.5ZM7 12.25C7 17.5 3.5 17.5 3.5 17.5L1.75 21L5.25 21C9.1175 21 12.25 16.1175 12.25 12.25L12.25 5.3044e-07L-7.14705e-08 -5.40489e-07L-1.1424e-06 12.25L7 12.25Z" fill="white"/>
                                  </svg>
                              </span>
                            </article>
                            <article class="hm2-feedback-item bg-white position-relative swiper-slide">
                                <img src="assets/img/star-5.svg" alt="star rating" class="img-fluid" /><br />
                                <img src="assets/img/reviewimg/francereview07.webp" alt="joomla" class="img-fluid flex-shrink-0 m-3" />                                
                                <p class="quote-text mb-30 mt-4"> “Serveur stable. Bon service client. Très reactif.”</p>
                                <div class="clients-info d-flex align-items-center">
                                    <div class="clients-designation ms-3">
                                        <h6 class="mb-1">Thomas Verhoeven</h6>
                                        <span>Liège</span>
                                    </div>
                                </div>
                                <span class="quote-icon position-absolute text-center rounded-circle text-white">
                                  <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path opacity="0.8" d="M19.25 17.5L17.5 21L21 21C24.8675 21 28 16.1175 28 12.25L28 1.90735e-06L15.75 8.3642e-07L15.75 12.25L22.75 12.25C22.75 17.5 19.25 17.5 19.25 17.5ZM7 12.25C7 17.5 3.5 17.5 3.5 17.5L1.75 21L5.25 21C9.1175 21 12.25 16.1175 12.25 12.25L12.25 5.3044e-07L-7.14705e-08 -5.40489e-07L-1.1424e-06 12.25L7 12.25Z" fill="white"/>
                                  </svg>
                              </span>
                            </article>
                            <article class="hm2-feedback-item bg-white position-relative swiper-slide">
                                <img src="assets/img/star-5.svg" alt="star rating" class="img-fluid" /><br />
                                <img src="assets/img/reviewimg/francereview08.webp" alt="joomla" class="img-fluid flex-shrink-0 m-3" />                                
                                <p class="quote-text mb-30 mt-4"> "Service client très réactif, les délais de réception sont excellents ! Je recommande vivement tout est parfait !"</p>
                                <div class="clients-info d-flex align-items-center">
                                    <div class="clients-designation ms-3">
                                        <h6 class="mb-1">Maxime</h6>
                                        <span>Montpellier</span>
                                    </div>
                                </div>
                                <span class="quote-icon position-absolute text-center rounded-circle text-white">
                                  <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path opacity="0.8" d="M19.25 17.5L17.5 21L21 21C24.8675 21 28 16.1175 28 12.25L28 1.90735e-06L15.75 8.3642e-07L15.75 12.25L22.75 12.25C22.75 17.5 19.25 17.5 19.25 17.5ZM7 12.25C7 17.5 3.5 17.5 3.5 17.5L1.75 21L5.25 21C9.1175 21 12.25 16.1175 12.25 12.25L12.25 5.3044e-07L-7.14705e-08 -5.40489e-07L-1.1424e-06 12.25L7 12.25Z" fill="white"/>
                                  </svg>
                              </span>
                            </article>
                            <article class="hm2-feedback-item bg-white position-relative swiper-slide">
                                <img src="assets/img/star-5.svg" alt="star rating" class="img-fluid" /><br />
                                <img src="assets/img/reviewimg/francereview09.webp" alt="joomla" class="img-fluid flex-shrink-0 m-3" />                                
                                <p class="quote-text mb-30 mt-4"> "Je viens de l installé...rien à redire!!
                                    Tout est vrai!!!
                                    Merci beaucoup"</p>
                                <div class="clients-info d-flex align-items-center">
                                    <div class="clients-designation ms-3">
                                        <h6 class="mb-1">Gérald Suissa</h6>
                                        <span>Mechelen</span>
                                    </div>
                                </div>
                                <span class="quote-icon position-absolute text-center rounded-circle text-white">
                                  <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path opacity="0.8" d="M19.25 17.5L17.5 21L21 21C24.8675 21 28 16.1175 28 12.25L28 1.90735e-06L15.75 8.3642e-07L15.75 12.25L22.75 12.25C22.75 17.5 19.25 17.5 19.25 17.5ZM7 12.25C7 17.5 3.5 17.5 3.5 17.5L1.75 21L5.25 21C9.1175 21 12.25 16.1175 12.25 12.25L12.25 5.3044e-07L-7.14705e-08 -5.40489e-07L-1.1424e-06 12.25L7 12.25Z" fill="white"/>
                                  </svg>
                              </span>
                            </article>
                            <article class="hm2-feedback-item bg-white position-relative swiper-slide">
                                <img src="assets/img/star-5.svg" alt="star rating" class="img-fluid" /><br />
                                <div class="align-items-center align-item-center">
                                    <img src="assets/img/reviewimg/francereview10.webp" alt="joomla" class="img-fluid text-center align-item-centers flex-shrink-0 m-3" />
                                </div>                                
                                <p class="quote-text mb-30 mt-4"> "Tvplux a un super service. J'ai acheté un abonnement en ligne et en à peine 10 minutes j'avais les identifiants et ca fonctionnait bien. Je recommande."</p>
                                <div class="clients-info d-flex align-items-center">
                                    <div class="clients-designation ms-3">
                                        <h6 class="mb-1">Ryan</h6>
                                        <span>Paris</span>
                                    </div>
                                </div>
                                <span class="quote-icon position-absolute text-center rounded-circle text-white">
                                  <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path opacity="0.8" d="M19.25 17.5L17.5 21L21 21C24.8675 21 28 16.1175 28 12.25L28 1.90735e-06L15.75 8.3642e-07L15.75 12.25L22.75 12.25C22.75 17.5 19.25 17.5 19.25 17.5ZM7 12.25C7 17.5 3.5 17.5 3.5 17.5L1.75 21L5.25 21C9.1175 21 12.25 16.1175 12.25 12.25L12.25 5.3044e-07L-7.14705e-08 -5.40489e-07L-1.1424e-06 12.25L7 12.25Z" fill="white"/>
                                  </svg>
                              </span>
                            </article>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--feedback area end-->



<!--consult section start-->
<section class="consult-area position-relative zindex-1 overflow-hidden" data-background="assets/img/consult-bg.png">
    <img src="assets/img/section-curve.png" alt="curve" class="position-absolute curve w-100" />
    <div class="consult-overlay bg-secondary-gradient pt-120">
        <div class="container">
            <div class="row justify-content-between">
                <div class="col-lg-7 col-xl-6">
                    <div class="consult-left">
                        <h2>Comment ça marche?</h2>
                        <ul class="consult-list mt-5">
                            <li class="d-flex">
                                <span class="icon-box position-relative d-inline-flex align-items-center justify-content-center rounded-circle"><i class="fa-solid fa-circle-1 fa-xl"></i></span>
                                <div class="list-content ms-4">
                                    <h4 class="mb-3 mt-1">Passer votre commande</h4>
                                    <p>Passez votre commande en choisissant votre abonnement préféré.</p><br />
                                </div>
                            </li>
                            <li class="d-flex">
                                <span class="icon-box position-relative d-inline-flex align-items-center justify-content-center rounded-circle"><i class="fa-solid fa-circle-2 fa-xl"></i></span>
                                <div class="list-content ms-4">
                                    <h4 class="mb-3 mt-1">Obtenez votre compte</h4>
                                    <p>Après avoir effectué un paiement, vous serez contacté par e-mail en moins d’une 10 minute avec vos identifiants de connexion et un guide d'installation.</p>
                                </div>
                            </li>
                            <li class="d-flex">
                                <span class="icon-box position-relative d-inline-flex align-items-center justify-content-center rounded-circle"><i class="fa-solid fa-circle-3 fa-xl"></i></span>
                                <div class="list-content ms-4">
                                    <h4 class="mb-3 mt-1">Profitez de votre IPTV</h4>
                                    <p>Profitez maintenant de toutes les chaînes, films et séries !</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--consult section end-->

 <!--domain search-->
 <section class="domain-area light-bg mb-5">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="domain-search-box bg-white position-relative zindex-2 primary-shadow rounded-10">
                    <div class="row justify-content-center">
                        <div class="col-xl-7 col-lg-10">
                            <h2 class="h3 text-center">Choisissez Le Fournisseur <mark class="position-relative">IPTV</mark> Numéro 1 En Europe</h2>
                            <form action="#" class="mt-1 domain-search-form position-relative d-flex align-items-center justify-content-between btn-block">
                                <a href="#pricing" class="template-btn primary-btn btn-block w-100 flex-shrink-0 border-0 text-center">Commander maintenant</a>
                            </form>
                            <div class="domain-info mt-1 d-flex justify-content-center align-items-center">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--domain search end-->
       

        
<!--applications area start-->
<section class="application-area light-bg pb-120 position-relative zindex-1 overflow-hidden">
    <img src="assets/img/shapes/box-shape.png" alt="box-shape" class="position-absolute left-bottom" />
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-7">
                <div class="section-title text-center">
                    <h2>MARCHE AVEC TOUS VOS APPAREILS.</h2>
                </div>
            </div>
        </div>
        <div class="app_lists mt-5">
            <div class="row g-4 justify-content-center">
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/chrom.png" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/sams.png" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/applelog.png" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/micro.png" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/firetv.png" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/androidtv copy.png" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/x96.png" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/lg.png" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/tosh.png" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/tcl.png" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/sharp.png" alt="joomla" class="img-fluid flex-shrink-0" />                    
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                    <img src="assets/img/brands/sony.png" alt="joomla" class="img-fluid flex-shrink-0" />                    
                </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/android.png" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/amz.png" alt="joomla" class="img-fluid h-100 flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/xbox.png" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/formuller.png" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/lonov.png" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4">
                    <div class="app_list_item bg-white deep-shadow rounded-2 d-flex align-items-center">
                        <img src="assets/img/brands/phili.png" alt="joomla" class="img-fluid flex-shrink-0" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--applications area end-->
        

<!--FAQ Start-->

<section class="faq-modern-section">
    <div class="container">
        <div class="faq-modern-header text-center mb-5">
            <span class="faq-modern-label">FAQ</span>
            <h2 class="faq-modern-title">Questions Fréquemment Posées</h2>
            <p class="faq-modern-subtitle">Découvrez les réponses aux questions les plus courantes sur notre service IPTV.</p>
        </div>
        <div class="row g-4" id="faqAccordion">

            <div class="col-lg-6 col-md-12">
                <div class="faq-modern-card faq-open">
                    <a href="#faqCollapseOne" class="faq-modern-trigger text-decoration-none" data-bs-toggle="collapse" aria-expanded="true" aria-controls="faqCollapseOne">
                        <div class="faq-modern-trigger-inner">
                            <div class="faq-modern-icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="15" height="15" fill="#ffffff"><path d="M240.5 224H352C365.3 224 376.3 232.9 379.5 245.8s-2.3 26.1-13.5 34l-160 112c-10.6 7.4-24.7 7.9-35.7 1.1S154.5 375.4 157 362.7L176 272H64C50.7 272 39.7 263.1 36.5 250.2s2.3-26.1 13.5-34l160-112c10.6-7.4 24.7-7.9 35.7-1.1s16.3 18.1 13.8 30.9L240.5 224z"/></svg></div>
                            <h5 class="faq-modern-question">Le prix est-il mensuel ? Vais-je être facturé à nouveau ?</h5>
                            <div class="faq-modern-toggle"><span class="faq-toggle-minus">−</span><span class="faq-toggle-plus">+</span></div>
                        </div>
                    </a>
                    <div id="faqCollapseOne" class="collapse show" data-bs-parent="#faqAccordion">
                        <div class="faq-modern-body">Non, c'est un paiement unique. Nous ne facturons pas de frais mensuels et nous ne renouvelons pas automatiquement votre abonnement. Vous payez une seule fois et obtenez l'accès pour la période choisie (par exemple, un an, 15 mois ou 24 mois...).</div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="faq-modern-card">
                    <a href="#faqCollapseTwo" class="faq-modern-trigger text-decoration-none" data-bs-toggle="collapse" aria-expanded="false" aria-controls="faqCollapseTwo">
                        <div class="faq-modern-trigger-inner">
                            <div class="faq-modern-icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="15" height="15" fill="#ffffff"><path d="M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"/></svg></div>
                            <h5 class="faq-modern-question">Comment s'abonner à IPTV ?</h5>
                            <div class="faq-modern-toggle"><span class="faq-toggle-minus">−</span><span class="faq-toggle-plus">+</span></div>
                        </div>
                    </a>
                    <div id="faqCollapseTwo" class="collapse" data-bs-parent="#faqAccordion">
                        <div class="faq-modern-body">Pour vous abonner à IPTV, visitez notre site web et choisissez un abonnement adapté à vos besoins. Vous serez redirigé vers un autre site pour finaliser votre paiement. Une fois cela terminé, vous recevrez vos codes avec des instructions détaillées.</div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="faq-modern-card">
                    <a href="#faqCollapseSeven" class="faq-modern-trigger text-decoration-none" data-bs-toggle="collapse" aria-expanded="false" aria-controls="faqCollapseSeven">
                        <div class="faq-modern-trigger-inner">
                            <div class="faq-modern-icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="15" height="15" fill="#ffffff"><path d="M256 48a208 208 0 1 1 0 416A208 208 0 1 1 256 48zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H272V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg></div>
                            <h5 class="faq-modern-question">Pourquoi suis-je redirigé vers un autre site pour finaliser mon achat ?</h5>
                            <div class="faq-modern-toggle"><span class="faq-toggle-minus">−</span><span class="faq-toggle-plus">+</span></div>
                        </div>
                    </a>
                    <div id="faqCollapseSeven" class="collapse" data-bs-parent="#faqAccordion">
                        <div class="faq-modern-body">Pour des transactions sécurisées, vous êtes redirigé vers le site de notre partenaire de paiement de confiance. Une fois votre achat finalisé, vous recevrez votre code d'activation IPTV par e-mail.</div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="faq-modern-card">
                    <a href="#faqCollapseEight" class="faq-modern-trigger text-decoration-none" data-bs-toggle="collapse" aria-expanded="false" aria-controls="faqCollapseEight">
                        <div class="faq-modern-trigger-inner">
                            <div class="faq-modern-icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="15" height="15" fill="#ffffff"><path d="M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"/></svg></div>
                            <h5 class="faq-modern-question">Puis-je payer mon abonnement avec PayPal ?</h5>
                            <div class="faq-modern-toggle"><span class="faq-toggle-minus">−</span><span class="faq-toggle-plus">+</span></div>
                        </div>
                    </a>
                    <div id="faqCollapseEight" class="collapse" data-bs-parent="#faqAccordion">
                        <div class="faq-modern-body">Oui, vous pouvez payer avec PayPal, Crypto ou d'autres méthodes. Envoyez-nous un message sur WhatsApp pour obtenir un lien direct. <a href="https://wa.me/33756756461" target="_blank" class="faq-whatsapp-link"><i class="fa-brands fa-whatsapp"></i> +33 756 756461</a></div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="faq-modern-card">
                    <a href="#faqCollapseThree" class="faq-modern-trigger text-decoration-none" data-bs-toggle="collapse" aria-expanded="false" aria-controls="faqCollapseThree">
                        <div class="faq-modern-trigger-inner">
                            <div class="faq-modern-icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="15" height="15" fill="#ffffff"><path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/></svg></div>
                            <h5 class="faq-modern-question">Comment recevoir mon abonnement ?</h5>
                            <div class="faq-modern-toggle"><span class="faq-toggle-minus">−</span><span class="faq-toggle-plus">+</span></div>
                        </div>
                    </a>
                    <div id="faqCollapseThree" class="collapse" data-bs-parent="#faqAccordion">
                        <div class="faq-modern-body">Après le paiement, vous recevrez vos identifiants par e-mail sous 10 à 30 minutes. Vérifiez votre dossier spam. Si vous ne recevez rien, contactez-nous sur WhatsApp : <a href="https://wa.me/33756756461" target="_blank" class="faq-whatsapp-link"><i class="fa-brands fa-whatsapp"></i> +33 756 756461</a></div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="faq-modern-card">
                    <a href="#faqCollapseFour" class="faq-modern-trigger text-decoration-none" data-bs-toggle="collapse" aria-expanded="false" aria-controls="faqCollapseFour">
                        <div class="faq-modern-trigger-inner">
                            <div class="faq-modern-icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="15" height="15" fill="#ffffff"><path d="M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"/></svg></div>
                            <h5 class="faq-modern-question">Puis-je utiliser l'IPTV sur plusieurs appareils simultanément ?</h5>
                            <div class="faq-modern-toggle"><span class="faq-toggle-minus">−</span><span class="faq-toggle-plus">+</span></div>
                        </div>
                    </a>
                    <div id="faqCollapseFour" class="collapse" data-bs-parent="#faqAccordion">
                        <div class="faq-modern-body">Oui, si vous avez un abonnement Gold, vous pouvez regarder sur plusieurs appareils simultanément.</div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="faq-modern-card">
                    <a href="#faqCollapseFive" class="faq-modern-trigger text-decoration-none" data-bs-toggle="collapse" aria-expanded="false" aria-controls="faqCollapseFive">
                        <div class="faq-modern-trigger-inner">
                            <div class="faq-modern-icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="15" height="15" fill="#ffffff"><path d="M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.5 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.5-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"/></svg></div>
                            <h5 class="faq-modern-question">Ai-je besoin d'une antenne satellite pour utiliser l'IPTV ?</h5>
                            <div class="faq-modern-toggle"><span class="faq-toggle-minus">−</span><span class="faq-toggle-plus">+</span></div>
                        </div>
                    </a>
                    <div id="faqCollapseFive" class="collapse" data-bs-parent="#faqAccordion">
                        <div class="faq-modern-body">Non, vous vous connectez aux serveurs IPTV TVPLUX via Internet. Vous n'avez pas besoin d'une parabole ou d'un équipement satellite.</div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="faq-modern-card">
                    <a href="#faqCollapseSix" class="faq-modern-trigger text-decoration-none" data-bs-toggle="collapse" aria-expanded="false" aria-controls="faqCollapseSix">
                        <div class="faq-modern-trigger-inner">
                            <div class="faq-modern-icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="15" height="15" fill="#ffffff"><path d="M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.5 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.5-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"/></svg></div>
                            <h5 class="faq-modern-question">Ce service (IPTV) fonctionne-t-il dans mon pays ?</h5>
                            <div class="faq-modern-toggle"><span class="faq-toggle-minus">−</span><span class="faq-toggle-plus">+</span></div>
                        </div>
                    </a>
                    <div id="faqCollapseSix" class="collapse" data-bs-parent="#faqAccordion">
                        <div class="faq-modern-body">L'IPTV fonctionne partout dans le monde. Tant que vous disposez d'une connexion Internet stable, vous pouvez regarder des milliers de chaînes TV.</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<!--FAQ End-->


        <!-- Footer Area -->
         <!-- Footer Area End -->


    
    <!-- main content wrapper ends -->


    <!--build:js-->
    
    
    
    
    
    
    
    
    
    
    
    
     <!-- Add Facebook Pixel Script -->
    

    <!-- Pricing toggle (Standard / Multi-Screen) -->
    
    
    <!--=============== SWIPER JS ===============-->
    

    <!--=============== MAIN JS ===============-->
    
    
    <a href="https://wa.me/33756756461" class="float d-none" target="_blank">
    <i class="fa-brands fa-whatsapp my-float"></i>
    </a>
    
    

    <!--endbuild-->

 
</div>` }} />
  );
}
